<template>
  <div class="application-list">
    <div class="list-table__title">Applicaiton list</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="applications"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(Detail)="application">
        <div>
          <b-button
            pill
            variant="outline-secondary"
            :to="{
              name: 'ApplicationDetail',
              params: { applicationId: application.item.id }
            }"
            class="mb-1"
          >
            Detail
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import {
  Application,
  ApplicationStatus,
  applicationStatusCode,
  ApplicationType,
  applicationTypeCode,
} from '@/store/applications/types'
import { Student } from '@/store/students/types'
import { RootState } from '@/store/types'
import { Moment } from 'moment'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ApplicationsTable extends Vue {
  private fields = [
    {
      key: 'id',
      label: 'Application ID',
    },
    {
      key: 'applicant.name',
      label: 'Applicant Name',
    },
    {
      key: 'applicationDate',
      label: 'Date',
      formatter: (applicationDate: Moment): string => applicationDate.format('YYYY/MM/DD'),
    },
    {
      key: 'type',
      label: 'Application Type',
      formatter: (type: applicationTypeCode): string => ApplicationType[type],
    },
    {
      key: 'student.studentNumber',
      label: 'Student Number',
      formatter: (studentNumber: string|undefined): string => studentNumber || '-',
    },
    {
      key: 'student.name',
      label: 'Student Name',
      formatter: (name: string|undefined): string => name || '-',
    },
    {
      key: 'status',
      label: 'Status',
      formatter: (status: applicationStatusCode): string => ApplicationStatus[status],
    },
    {
      key: 'Detail',
    },
  ]

  private get applications(): Application[] {
    return (this.$store.state as RootState).applications.applications
  }
}
</script>

<style lang="scss">
.application-list {
  .list-table {
    .list-table__head {
      font-size: .7rem;
    }

    .list-table__head th {
      vertical-align: middle;
    }

    .list-table__body td {
      font-size: .7rem;
      line-break: auto;
    }
  }

  .btn {
    min-width: 80px;
    padding: 10px 20px;
    font-size: 0.85rem;
    line-height: .5;
  }
}
</style>
